import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="HOW TO PLAY" isOpen={isOpen} handleClose={handleClose}>
      <div className="space-y-4">
        <p className="text-sm leading-relaxed text-slate-600">
          Guess the Clashdle word in <strong>6 tries</strong>. After each guess, the color of the tiles will
          change to show how close your guess was to the word.
        </p>

        <div className="border-t border-slate-200 pt-4">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
            Examples
          </p>

          <div className="mb-1 mt-3 flex justify-center">
            <Cell
              isRevealing={true}
              isCompleted={true}
              value="W"
              status="correct"
            />
            <Cell value="E" isCompleted={true} />
            <Cell value="A" isCompleted={true} />
            <Cell value="R" isCompleted={true} />
            <Cell value="Y" isCompleted={true} />
          </div>
          <p className="text-sm text-slate-600">
            <strong className="font-bold text-green-600">W</strong> is in the word and in the <strong>correct spot</strong>.
          </p>

          <div className="mb-1 mt-4 flex justify-center">
            <Cell value="P" isCompleted={true} />
            <Cell value="I" isCompleted={true} />
            <Cell
              isRevealing={true}
              isCompleted={true}
              value="L"
              status="present"
            />
            <Cell value="O" isCompleted={true} />
            <Cell value="T" isCompleted={true} />
          </div>
          <p className="text-sm text-slate-600">
            <strong className="font-bold text-yellow-600">L</strong> is in the word but in the <strong>wrong spot</strong>.
          </p>

          <div className="mb-1 mt-4 flex justify-center">
            <Cell value="V" isCompleted={true} />
            <Cell value="A" isCompleted={true} />
            <Cell value="G" isCompleted={true} />
            <Cell isRevealing={true} isCompleted={true} value="U" status="absent" />
            <Cell value="E" isCompleted={true} />
          </div>
          <p className="text-sm text-slate-600">
            <strong className="font-bold text-slate-400">U</strong> is <strong>not in the word</strong> in any spot.
          </p>
        </div>

        <div className="border-t border-slate-200 pt-4">
          <p className="text-center text-sm font-semibold text-clash-blue">
            A new word is available each day!
          </p>
        </div>
      </div>
    </BaseModal>
  )
}
